<template>
  <tooltip
    :text="tooltipContent"
    target=".ai-beta-badge-wrapper"
    :aria-label="tooltipContent"
    placement="top">
    <div class="ai-beta-badge-wrapper ai-bg" tabindex="0">
      <div class="ai-beta-badge">
        <span class="ai-text-color">
          <img
            class="ai-logo"
            src="~@/assets/ai_stars_color.svg"
            alt="AI Powered Feature">
          AI Beta
        </span>
      </div>
    </div>
  </tooltip>
</template>

<script>
export default {
  name: 'AIBetaBadge',
  data() {
    return {
      tooltipContent: 'This new feature integrates AI technology and is in active development. Your feedback will help us improve it.'
    }
  }
}
</script>

<style scoped lang="less">
@import "~@/variables.less";
.ai-beta-badge-wrapper {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 11rem;
  padding: 0.1rem;
}
.ai-beta-badge {
  background: @background-light-gray;
  padding: var(--spacing-xxs) 0.6rem;
  border-radius: 10rem;
  font-weight: 400;
  font-size: 0.875rem;
  display: inline-block;

  .ai-logo {
    width: 10px;
    height: var(--size-icon-xs);
  }
}
</style>
